import React from 'react';

export const VerticalDividerIcon = () => {
  return (
    <svg
      width="1"
      height="24"
      viewBox="0 0 1 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1" height="24" fill="#D9D9D9" />
    </svg>
  );
};
